import React from 'react'
import { Absolute } from '@/src/components/parts/bases/Absolute'

type Props = {
  displayPosition: 'top' | 'bottom'
  className?: string
}

export const ScrollFixedView = (props: Props) => {
  return (
    <>
      <Absolute className={`left-0 z-10 max-h-[24px] min-h-[24px] w-full ${props.className}`}>
        <div
          className="h-6 max-h-[24px] min-h-[24px] w-full overflow-visible"
          style={{
            background:
              props.displayPosition === 'top'
                ? 'linear-gradient(0, rgba(0, 0, 0, 0.00) 0%, #000 100%)'
                : 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)',
            flexShrink: 0,
          }}
        ></div>
      </Absolute>
    </>
  )
}
